import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DeleteOutlined } from "@ant-design/icons";

const SortableItem = ({ id, property, index, onDelete }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "10px",
    marginBottom: "8px",
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "grab"
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} >
      <div {...listeners} className="left-section-map">
        <div className="drag-icon">⋮⋮</div>
      </div>

      <div className="middle-section">
        <div className="schedule-info">
          <span className="number-circle">{index + 1}</span>
        </div>
        <div className="address-line">
          {property.distanceText && property.durationText ? (
            <span className="distance-time">
              {property.distanceText}, {property.durationText}
            </span>
          ) : (
            <span className="distance-time text-muted">Distance pending</span>
          )}
          <span className="new-label">New</span>
          <div>
            {property.address}
            <span className="duration">
              {property.inspectionStart && property.inspectionEnd
                ? ` - ${property.inspectionStart} to ${property.inspectionEnd}`
                : ""}
            </span>
          </div>
        </div>
      </div>

      <div className="right-section-map">
        <DeleteOutlined
          className="delete-icon-map"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(property);
          }}
        />
      </div>
    </div>
  );
};

export default SortableItem;
